import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import HomePage from './pages/master/HomePage';
import AboutPage from './pages/master/AboutPage';
import AcademicsPage from './pages/master/AcademicsPage';
import AdmissionsPage from './pages/master/AdmissionsPage';
import LifePage from './pages/master/LifePage';
import ContactPage from './pages/master/ContactPage';
import EventDetail from './pages/master/EventDetail';

import SchoolLayout from './pages/school/SchoolLayout';
import SchoolHomePage from "./pages/school/SchoolHomePage";
import SchoolAboutPage from "./pages/school/SchoolAboutPage";
import MandatoryDisclosure from './pages/school/MandatoryDisclosure';
import SchoolAcademicPage from "./pages/school/SchoolAcademicPage";
import SchoolLifePage from "./pages/school/SchoolLifePage";
import SchoolAdmissionPage from "./pages/school/SchoolAdmissionPage";
import SchoolContactPage from "./pages/school/SchoolContactPage";
import SchoolEventDetail from './pages/school/SchoolEventDetail';
import SchoolTeamPage from './pages/school/SchoolTeamPage';
import SchoolsListPage from './pages/SchoolsListPage';

import './App.css';
import AuthRoute from "./components/AdminComponents/AuthRoute";
import SchoolRoute from "./components/AdminComponents/SchoolRoute";
import Unauthorized from "./pages/adminPages/Unauthorized";
import AdminLoginLayout from './components/AdminComponents/AdminLoginLayout';
import AdminLayout from './components/AdminComponents/AdminLayout';
import AdminDashboard from './pages/adminPages/AdminDashboard';
import HomeAboutSection from './pages/adminPages/HomeAboutSection';
import HomeMissionVissionSection from './pages/adminPages/HomeMissionVissionSection';
import AdminAboutSection from './pages/adminPages/AdminAboutSection';
import AdminMissionVisionSection from './pages/adminPages/AdminMissionVisionSection';
import AffiliationsCertificationsSection from './pages/adminPages/AffiliationsCertificationsSection';
import AccoladesAwardsSection from './pages/adminPages/AccoladesAwardsSection';
import CSRSection from './pages/adminPages/CSRSection';
import MentorshipSection from './pages/adminPages/MentorshipSection';
import PrePrimaryProgramSection from './pages/adminPages/PrePrimaryProgramSection';
import PrimaryProgramSection from './pages/adminPages/PrimaryProgramSection';
import SeniorSection from './pages/adminPages/SeniorSection';
import SeniorSecondarySection from './pages/adminPages/SeniorSecondarySection';
import LifeAtTIGPSSection from './pages/adminPages/LifeAtTIGPSSection';
import Gallery from './pages/adminPages/Gallery';
import Videos from './pages/adminPages/Videos';
import Achievers from './pages/adminPages/Achievers';
import EventList from './pages/adminPages/EventList';
import NewsClippings from './pages/adminPages/NewsClippings'
import CriteriaSection from './pages/adminPages/CriteriaSection';
import AdmissionApplicationProcedureSection from './pages/adminPages/AdmissionApplicationProcedureSection';
import GuestRoute from "./components/AdminComponents/GuestRoute";
import GeneralSettings from "./pages/adminPages/GeneralSettings";
import SchoolUniform from "./pages/adminPages/SchoolUniform";
import AdminMandatoryDisclosure from "./pages/adminPages/MandatoryDisclosure";
import FileUpload from "./pages/adminPages/FileUpload";
import AdmissionOverview from "./pages/adminPages/AdmissionOverview";
import NewsLetter from './pages/adminPages/NewsLetter';
import TechnoEcho from './pages/adminPages/TechnoEcho';
import Prospectus from './pages/adminPages/Prospectus';
import WhyChooseUs from './pages/adminPages/WhyChooseUs';
import SchoolList from './pages/adminPages/SchoolList';


import AdminEnqLayout from './components/AdminComponents/AdminEnqLayout';
import EnquiryDashboardDetail from './pages/adminPages/EnquiryDashboardDetail';
import EnquiryDetail from './pages/adminPages/EnquiryDetail';

import QuestionBankLogin from './components/QuestionBankLogin';
import QuestionBankReset from './components/QuestionBankReset';
import QuestionBank from './components/QuestionBank';
import TechnoAep from './components/TechnoAep';
import TechnoAepDigital from './components/TechnoAepDigital';

function App() {
  return (
    <div className="App">
      <Routes>
        {/* Master Routes */}
        <Route path="/" element={<Layout><HomePage /></Layout>} />
        <Route path="/about" element={<Layout><AboutPage /></Layout>} />
        <Route path="/academics" element={<Layout><AcademicsPage /></Layout>} />
        <Route path="/admissions" element={<Layout><AdmissionsPage /></Layout>} />
        <Route path="/life-at-tigps" element={<Layout><LifePage /></Layout>} />
        <Route path="/events/:eventId" element={<Layout><EventDetail /></Layout>} />
        <Route path="/contact" element={<Layout><ContactPage /></Layout>} />
        <Route path="/schools" element={<Layout><SchoolsListPage /></Layout>} />




        {/* ✅ COMMON SCHOOL PAGE */}
        <Route path=":school_slug/about" element={<SchoolLayout><SchoolAboutPage /></SchoolLayout>} />
        <Route path=":school_slug/academics" element={<SchoolLayout><SchoolAcademicPage /></SchoolLayout>} />
        <Route path=":school_slug/mandatory-public-disclosure" element={<SchoolLayout><MandatoryDisclosure /></SchoolLayout>} />
        <Route path=":school_slug/life-at-tigps" element={<SchoolLayout><SchoolLifePage /></SchoolLayout>} />
        <Route path=":school_slug/admissions" element={<SchoolLayout><SchoolAdmissionPage /></SchoolLayout>} />
        <Route path=":school_slug/contact" element={<SchoolLayout><SchoolContactPage /></SchoolLayout>} />
        <Route path=":school_slug/events/:eventId" element={<SchoolLayout><SchoolEventDetail /></SchoolLayout>} />
        <Route path=":school_slug" element={<SchoolLayout><SchoolHomePage /></SchoolLayout>} />
        <Route path=":school_slug/school-team" element={<SchoolLayout><SchoolTeamPage /></SchoolLayout>} />
        <Route path=":school_slug" element={<SchoolLayout />} />
        <Route path="/unauthorized" element={<Unauthorized />} />


        {/*------- ADMIN SECTION*/}
        <Route path="*" element={<Unauthorized />} />
        <Route path="/admin/unauthorized" element={<Unauthorized />} />
        <Route path="/admin" element={<GuestRoute><AdminLoginLayout></AdminLoginLayout></GuestRoute>} />
        <Route path="/admin/dashboard" element={<AuthRoute><AdminLayout><AdminDashboard /></AdminLayout></AuthRoute>} />
        <Route path="/admin/home-page/home-about-section/:school_slug" element={<SchoolRoute><AdminLayout><HomeAboutSection /></AdminLayout></SchoolRoute>} />
        <Route path="/admin/home-page/mission-vision-section/:school_slug" element={<SchoolRoute><AdminLayout><HomeMissionVissionSection /></AdminLayout></SchoolRoute>} />
        <Route path="/admin/home-page/achievers/:school_slug" element={<SchoolRoute><AdminLayout><Achievers /></AdminLayout></SchoolRoute>} />
        <Route path="/admin/home-page/why-choose-us/:school_slug" element={<SchoolRoute><AdminLayout><WhyChooseUs /></AdminLayout></SchoolRoute>} />
        <Route path="/admin/about-page/about-section/:school_slug" element={<SchoolRoute><AdminLayout><AdminAboutSection /></AdminLayout></SchoolRoute>} />
        <Route path="/admin/about-page/mission-vision-section/:school_slug" element={<SchoolRoute><AdminLayout><AdminMissionVisionSection /></AdminLayout></SchoolRoute>} />
        <Route path="/admin/about-page/affiliations-certifications-section/:school_slug" element={<SchoolRoute><AdminLayout><AffiliationsCertificationsSection /></AdminLayout></SchoolRoute>} />
        <Route path="/admin/about-page/accolades-awards-section/:school_slug" element={<SchoolRoute><AdminLayout><AccoladesAwardsSection /></AdminLayout></SchoolRoute>} />
        <Route path="/admin/about-page/csr-section/:school_slug" element={<SchoolRoute><AdminLayout><CSRSection /></AdminLayout></SchoolRoute>} />
        <Route path="/admin/about-page/mentorship-section/:school_slug" element={<SchoolRoute><AdminLayout><MentorshipSection /></AdminLayout></SchoolRoute>} />
        <Route path="/admin/academic-page/pre-primary-program-section/:school_slug" element={<SchoolRoute><AdminLayout><PrePrimaryProgramSection /></AdminLayout></SchoolRoute>} />
        <Route path="/admin/academic-page/primary-program-section/:school_slug" element={<SchoolRoute><AdminLayout><PrimaryProgramSection /></AdminLayout></SchoolRoute>} />
        <Route path="/admin/academic-page/senior-section/:school_slug" element={<SchoolRoute><AdminLayout><SeniorSection /></AdminLayout></SchoolRoute>} />
        <Route path="/admin/academic-page/senior-secondary-section/:school_slug" element={<SchoolRoute><AdminLayout><SeniorSecondarySection /></AdminLayout></SchoolRoute>} />
        <Route path="/admin/academic-page/mandatory-disclosure/:school_slug" element={<SchoolRoute><AdminLayout><AdminMandatoryDisclosure /></AdminLayout></SchoolRoute>} />
        <Route path="/admin/life-at-tigps-page/life-at-tigps-section/:school_slug" element={<SchoolRoute><AdminLayout><LifeAtTIGPSSection /></AdminLayout></SchoolRoute>} />
        <Route path="/admin/life-at-tigps-page/gallery/:school_slug" element={<SchoolRoute><AdminLayout><Gallery /></AdminLayout></SchoolRoute>} />
        <Route path="/admin/life-at-tigps-page/videos/:school_slug" element={<SchoolRoute><AdminLayout><Videos /></AdminLayout></SchoolRoute>} />
        <Route path="/admin/life-at-tigps-page/news-clippings/:school_slug" element={<SchoolRoute><AdminLayout><NewsClippings /></AdminLayout></SchoolRoute>} />
        <Route path="/admin/life-at-tigps-page/event-list/:school_slug" element={<SchoolRoute><AdminLayout><EventList /></AdminLayout></SchoolRoute>} />
        <Route path="/admin/life-at-tigps-page/newsletter/:school_slug" element={<SchoolRoute><AdminLayout><NewsLetter /></AdminLayout></SchoolRoute>} />
        <Route path="/admin/life-at-tigps-page/techno-echo/:school_slug" element={<SchoolRoute><AdminLayout><TechnoEcho /></AdminLayout></SchoolRoute>} />
        <Route path="/admin/life-at-tigps-page/prospectus/:school_slug" element={<SchoolRoute><AdminLayout><Prospectus /></AdminLayout></SchoolRoute>} />
        <Route path="/admin/admission-page/admission-overview/:school_slug" element={<SchoolRoute><AdminLayout><AdmissionOverview /></AdminLayout></SchoolRoute>} />
        <Route path="/admin/admission-page/criteria-section/:school_slug" element={<SchoolRoute><AdminLayout><CriteriaSection /></AdminLayout></SchoolRoute>} />
        <Route path="/admin/admission-page/admission-application-procedure-section/:school_slug" element={<SchoolRoute><AdminLayout><AdmissionApplicationProcedureSection /></AdminLayout></SchoolRoute>} />
        <Route path="/admin/admission-page/school-uniform/:school_slug" element={<SchoolRoute><AdminLayout><SchoolUniform /></AdminLayout></SchoolRoute>}></Route>
        <Route path="/admin/general-settings/:school_slug" element={<SchoolRoute><AdminLayout><GeneralSettings /></AdminLayout></SchoolRoute>}></Route>
        <Route path="/admin/file-upload/:school_slug" element={<SchoolRoute><AdminLayout><FileUpload /></AdminLayout></SchoolRoute>}></Route>
        <Route path="/admin/school-list/:school_slug" element={<AuthRoute><AdminLayout><SchoolList /></AdminLayout></AuthRoute>}></Route>


        {/* ---------- Enquiry Detail ----------- */}
        <Route path='/admin/enquiry-dashboard/:school_slug' element={<SchoolRoute><AdminEnqLayout><EnquiryDashboardDetail /></AdminEnqLayout></SchoolRoute>}></Route>
        <Route path="/admin/enquiry-detail/:school_slug" element={<SchoolRoute><AdminEnqLayout><EnquiryDetail /></AdminEnqLayout></SchoolRoute>}></Route>


        {/* ------------ Question Bank & Techno AEP ------------ */}
        <Route path="/question-bank-login" element={<Layout><QuestionBankLogin /></Layout>} />
        <Route path="/set-tigps-question-bank-password" element={<Layout><QuestionBankReset /></Layout>} />
        <Route path="/question-bank" element={<Layout><QuestionBank /></Layout>} />
        <Route path='/aep-digital-library' element={<Layout><TechnoAepDigital /></Layout>} />
        <Route path='/aep-questions-hub' element={<Layout><TechnoAep /></Layout>} />
      </Routes>
    </div>
  );
}

export default App;